"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Input_1 = require("./Input");
exports.Textarea = Input_1.Input.withComponent('textarea');
exports.Textarea.displayName = 'Textarea';
//# sourceMappingURL=Textarea.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@skeoh/pic/out/build/components/Textarea.js
// module id = 548
// module chunks = 0